import { useEffect, useRef, useState } from 'react';
import { lookupUsZip } from '../utils/shopAuthApi';
import { isZip5 } from '../utils/usShopAddress';

const IDLE = { status: 'idle', info: null };

// Looks up a 5-digit US ZIP as it is typed: { status: 'idle' | 'checking' | 'found' |
// 'not_found' | 'error', info: { zip, state, cities } | null }. A newer ZIP always wins:
// the previous request is aborted and its answer ignored.
export default function useUsZipLookup(zip) {
    const [result, setResult] = useState(IDLE);
    const seqRef = useRef(0);

    useEffect(() => {
        const seq = ++seqRef.current;
        if (!isZip5(zip)) {
            setResult(IDLE);
            return undefined;
        }
        const controller = new AbortController();
        setResult({ status: 'checking', info: null });
        lookupUsZip(zip, { signal: controller.signal })
            .then((data) => {
                if (seq === seqRef.current) setResult({ status: 'found', info: data });
            })
            .catch((err) => {
                if (err?.name === 'AbortError' || seq !== seqRef.current) return;
                setResult({ status: err?.status === 404 ? 'not_found' : 'error', info: null });
            });
        return () => controller.abort();
    }, [zip]);

    return result;
}
